import { Attributes, SpanOptions } from "@opentelemetry/api";
import React from "react";

import { useRenderTracing } from "./useRenderTracing";

export const useTraceComponentRender = (
  operationName: string,
  attributes?: Attributes,
  options?: SpanOptions
) => {
  const endTrace = useRenderTracing(operationName, attributes, options);

  React.useEffect(() => {
    endTrace(); // End the tracing when the component has finished rendering
  }, [endTrace]);
};
